import React from 'react'
import classNames from 'classnames'

import LeadForm from './LeadForm/LeadForm'
import { LeadTypes } from '../../../includes/leadConstants'

import runModalContainer from './runModalContainer'
import './RunModal.css'
import LogoImage from '../../../assets/images/logo.jpg'

export const RunModal = ({ position, wantsToRun, enableRunningFor }) => {
  const modalDialogClassNames = classNames('modal-dialog', {
    'modal-lg': !wantsToRun,
  })

  return (
    <div
      className="modal fade RunModal"
      id="wantsToRunModal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className={modalDialogClassNames} role="document">
        <div className="modal-content">
          <div className="modal-header RunModal__Header">
            <img
              alt={`${process.env.REACT_APP_SITE_TITLE} Logo`}
              className="img-fluid RunModal__Logo"
              src={LogoImage}
            />
            <button
              type="button"
              className="close d-md-none"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body text-center">
            <div className="container-fluid">
              <div className="row">
                {wantsToRun ? (
                  <div className="col-md-8 offset-md-2">
                    <h2 className="my-4">Thank you!</h2>
                    <p>
                      A representative from the{' '}
                      <strong>{process.env.REACT_APP_SITE_TITLE}</strong> will
                      reach out to you shortly.
                    </p>
                    <button
                      className="btn btn-block btn-primary my-4"
                      data-dismiss="modal"
                      type="button"
                    >
                      Close
                    </button>
                  </div>
                ) : (
                  <div className="col-md-10 offset-md-1">
                    {!enableRunningFor && (
                      <React.Fragment>
                        <p className="mb-0">I am interested in running for</p>
                        <h4>{position.name}</h4>
                      </React.Fragment>
                    )}
                    <LeadForm
                      campaign="run_for_position"
                      lead_type={LeadTypes.FULL}
                      position_id={position.position_id}
                      tenant_id={process.env.REACT_APP_TENANT_ID}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default runModalContainer(RunModal)



// WEBPACK FOOTER //
// ./src/components/Position/RunModal/RunModal.js